var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0376 4.31617L11.6866 5.4791C12.2723 6.52858 12.0372 7.90532 11.1147 8.8278C11.1147 8.8278 11.1147 8.8278 11.1147 8.8278C11.1146 8.82792 9.99588 9.94685 12.0245 11.9755C14.0525 14.0035 15.1714 12.8861 15.1722 12.8853C15.1722 12.8853 15.1722 12.8853 15.1722 12.8853C16.0947 11.9628 17.4714 11.7277 18.5209 12.3134L19.6838 12.9624C21.2686 13.8468 21.4557 16.0692 20.0628 17.4622C19.2258 18.2992 18.2004 18.9505 17.0669 18.9934C15.1588 19.0658 11.9183 18.5829 8.6677 15.3323C5.41713 12.0817 4.93421 8.84122 5.00655 6.93309C5.04952 5.7996 5.7008 4.77423 6.53781 3.93723C7.93076 2.54428 10.1532 2.73144 11.0376 4.31617Z",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.598635401e00ea7034b8fe333be10623.svg";
export { ForwardRef as ReactComponent };